// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var IdAssetBundleFence;
(function (IdAssetBundleFence) {
    IdAssetBundleFence["ground_dirt_edge_horizontal"] = "ground_dirt_edge_horizontal";
    IdAssetBundleFence["ground_dirt_edge_vertical"] = "ground_dirt_edge_vertical";
    IdAssetBundleFence["ground_dirt_lane_single"] = "ground_dirt_lane_single";
    IdAssetBundleFence["mainFarmFence_construction_sign"] = "mainFarmFence_construction_sign";
    IdAssetBundleFence["mainFarmFence_gate_1"] = "mainFarmFence_gate_1";
    IdAssetBundleFence["mainFarmFence_gate_2"] = "mainFarmFence_gate_2";
    IdAssetBundleFence["mainFarmFence_gate_3"] = "mainFarmFence_gate_3";
    IdAssetBundleFence["mainFarmFence_gate_4"] = "mainFarmFence_gate_4";
    IdAssetBundleFence["mainFarmFence_gate_5"] = "mainFarmFence_gate_5";
    IdAssetBundleFence["mainFarmFence_gate_6"] = "mainFarmFence_gate_6";
    IdAssetBundleFence["mainFarmFence_gate_7"] = "mainFarmFence_gate_7";
    IdAssetBundleFence["mainFarmFence_piece_1"] = "mainFarmFence_piece_1";
    IdAssetBundleFence["mainFarmFence_piece_2"] = "mainFarmFence_piece_2";
    IdAssetBundleFence["mainFarmFence_piece_3"] = "mainFarmFence_piece_3";
    IdAssetBundleFence["mainFarmFence_piece_4"] = "mainFarmFence_piece_4";
    IdAssetBundleFence["mainFarmFence_piece_5"] = "mainFarmFence_piece_5";
    IdAssetBundleFence["mainFarmFence_piece_6"] = "mainFarmFence_piece_6";
    IdAssetBundleFence["mainFarmFence_piece_7"] = "mainFarmFence_piece_7";
    IdAssetBundleFence["mainFarmFence_pillar_big_bottom_1"] = "mainFarmFence_pillar_big_bottom_1";
    IdAssetBundleFence["mainFarmFence_pillar_big_bottom_2"] = "mainFarmFence_pillar_big_bottom_2";
    IdAssetBundleFence["mainFarmFence_pillar_big_bottom_3"] = "mainFarmFence_pillar_big_bottom_3";
    IdAssetBundleFence["mainFarmFence_pillar_big_bottom_4"] = "mainFarmFence_pillar_big_bottom_4";
    IdAssetBundleFence["mainFarmFence_pillar_big_bottom_5"] = "mainFarmFence_pillar_big_bottom_5";
    IdAssetBundleFence["mainFarmFence_pillar_big_bottom_6"] = "mainFarmFence_pillar_big_bottom_6";
    IdAssetBundleFence["mainFarmFence_pillar_big_bottom_7"] = "mainFarmFence_pillar_big_bottom_7";
    IdAssetBundleFence["mainFarmFence_pillar_big_leftright_1"] = "mainFarmFence_pillar_big_leftright_1";
    IdAssetBundleFence["mainFarmFence_pillar_big_leftright_2"] = "mainFarmFence_pillar_big_leftright_2";
    IdAssetBundleFence["mainFarmFence_pillar_big_leftright_3"] = "mainFarmFence_pillar_big_leftright_3";
    IdAssetBundleFence["mainFarmFence_pillar_big_leftright_4"] = "mainFarmFence_pillar_big_leftright_4";
    IdAssetBundleFence["mainFarmFence_pillar_big_leftright_5"] = "mainFarmFence_pillar_big_leftright_5";
    IdAssetBundleFence["mainFarmFence_pillar_big_leftright_6"] = "mainFarmFence_pillar_big_leftright_6";
    IdAssetBundleFence["mainFarmFence_pillar_big_leftright_7"] = "mainFarmFence_pillar_big_leftright_7";
    IdAssetBundleFence["mainFarmFence_pillar_big_top_1"] = "mainFarmFence_pillar_big_top_1";
    IdAssetBundleFence["mainFarmFence_pillar_big_top_2"] = "mainFarmFence_pillar_big_top_2";
    IdAssetBundleFence["mainFarmFence_pillar_big_top_3"] = "mainFarmFence_pillar_big_top_3";
    IdAssetBundleFence["mainFarmFence_pillar_big_top_4"] = "mainFarmFence_pillar_big_top_4";
    IdAssetBundleFence["mainFarmFence_pillar_big_top_5"] = "mainFarmFence_pillar_big_top_5";
    IdAssetBundleFence["mainFarmFence_pillar_big_top_6"] = "mainFarmFence_pillar_big_top_6";
    IdAssetBundleFence["mainFarmFence_pillar_big_top_7"] = "mainFarmFence_pillar_big_top_7";
    IdAssetBundleFence["mainFarmFence_pillar_small_1"] = "mainFarmFence_pillar_small_1";
    IdAssetBundleFence["mainFarmFence_pillar_small_2"] = "mainFarmFence_pillar_small_2";
    IdAssetBundleFence["mainFarmFence_pillar_small_3"] = "mainFarmFence_pillar_small_3";
    IdAssetBundleFence["mainFarmFence_pillar_small_4"] = "mainFarmFence_pillar_small_4";
    IdAssetBundleFence["mainFarmFence_pillar_small_5"] = "mainFarmFence_pillar_small_5";
    IdAssetBundleFence["mainFarmFence_pillar_small_6"] = "mainFarmFence_pillar_small_6";
    IdAssetBundleFence["mainFarmFence_pillar_small_7"] = "mainFarmFence_pillar_small_7";
})(IdAssetBundleFence || (IdAssetBundleFence = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/IdAssetBundleFence.ts
// module id = 2135
// module chunks = 3